import { adjustPerformersData } from './adjustPerformersData';

export const getAllPerformersRequest = profileId => {
  return adjustPerformersData();
};
